// src/pages/About/aboutTranslations.js
export const aboutTranslations = {
    en: {
      about_us: "About Us"
    },
    fr: {
      about_us: "À propos de nous"
    }
  };
